export default "__VITE_ASSET__7nXnoBHb__"